"use client"
import { type ReactNode } from "react"
import { useHudContext } from "../../shared/playbookHUDInfra"

type GalaxyHideProps = {
  children: ReactNode
  className?: string
  // Opt out of galaxy/epilogue hiding entirely. Use when the content is shown
  // inside an explicitly-opened surface (e.g. the mobile dashboard overlay,
  // which the user taps open) where the scroll-driven galaxy hide must not
  // apply — otherwise the content inherits `visibility:hidden` while scrolled
  // up and renders blank.
  forceVisible?: boolean
}

// Hides its children when the galaxy phase begins, or when the epilogue
// HUD mode is enabled. Wrap any HUD content other than the globe/graph and
// EpilogueParcel (which animate in galaxy/epilogue mode rather than hiding).
export const GalaxyHide = ({ children, className, forceVisible }: GalaxyHideProps) => {
  const ctx = useHudContext()
  const { epilogue } = ctx
  const style = forceVisible
    ? undefined
    : epilogue.isEpilogueHudMode ? epilogue.epilogueHiddenStyle : ctx.galaxyHideStyle
  return <div className={className} style={style}>{children}</div>
}
